import { Routes } from '@angular/router';
import { authGuard } from './core/guards/auth.guard';

export const routes: Routes = [
  {
    path: 'login',
    title: 'Login',
    loadComponent: () => import('./auth/pages/login/login.component'),
  },
  {
    path: 'notfound',
    title: 'Page not found',
    loadComponent: () => import('./dashboard/pages/page404/page404.component'),
  },
  {
    path: 'dashboard',
    loadComponent: () => import('./dashboard/dashboard.component'),
    canActivate: [authGuard],
    children: [
      // {
      //   path: 'home',
      //   title: 'Home',
      //   loadComponent: () => import('./dashboard/pages/home/home.component'),
      // },
      {
        path: 'kardex',
        title: 'Kardex',
        loadComponent: () => import('./dashboard/pages/kardex/kardex.component'),
      },
      {
        path: 'kardex/new',
        title: 'Kardex New',
        loadComponent: () => import('./dashboard/pages/kardex-new/kardex-new.component'),
        children: [
          {
            path: 'customer',
            title: 'Select Customer',
            loadComponent: () => import('./dashboard/pages/kardex-new/select-customer/select-customer.component'),
          },
          {
            path: 'products',
            title: 'Select Products',
            loadComponent: () => import('./dashboard/pages/kardex-new/select-products/select-products.component'),
          },
          {
            path: 'payment',
            title: 'Initial Payment',
            loadComponent: () => import('./dashboard/pages/kardex-new/payment/payment.component'),
          },
          {
            path: '',
            redirectTo: 'customer',
            pathMatch: 'full'
          }
        ]
      },
      {
        path: 'kardex/view/:id',
        title: 'Kardex View',
        loadComponent: () => import('./dashboard/pages/kardex-view/kardex-view.component'),
      },
      {
        path: 'kardex/view-extend/:id',
        title: 'Kardex View',
        loadComponent: () => import('./dashboard/pages/kardex-view-extend/kardex-view-extend.component'),
      },
      {
        path: 'customers',
        title: 'Customers',
        loadComponent: () => import('./dashboard/pages/customers/customers.component'),
      },
      {
        path: 'customers/new',
        title: 'New Customer',
        loadComponent: () => import('./dashboard/pages/customer/customer.component'),
      },
      {
        path: 'customers/edit/:id',
        title: 'Edit Customer',
        loadComponent: () => import('./dashboard/pages/customer/customer.component'),
      },
      {
        path: 'products',
        title: 'Products',
        loadComponent: () => import('./dashboard/pages/products/products.component'),
      },
      {
        path: '',
        redirectTo: 'kardex',
        pathMatch: 'full'
      }
    ]
  },
  {
    path: '',
    redirectTo: '/dashboard',
    pathMatch: 'full'
  },
  {
    path: '**',
    redirectTo: 'notfound'
  }
];
